module.exports = __webpack_public_path__ + "img/david-pro.9f3ce118.jpg";